import type { Locale } from "@/lib/i18n/config";

export function pickLocalized(
  locale: Locale,
  ar?: string | null,
  en?: string | null,
): string {
  const normalize = (value?: string | null) => {
    if (value === null || value === undefined) {
      return undefined;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  };
  const normalizedAr = normalize(ar);
  const normalizedEn = normalize(en);

  if (locale === "en") {
    return normalizedEn ?? normalizedAr ?? "";
  }

  return normalizedAr ?? normalizedEn ?? "";
}
